var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-loader-wrapper"},[_c('loader',{attrs:{"is-main-loader":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }